module.exports = __webpack_public_path__ + "static/media/ColumnCellFlotation_5.ede6c7ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simulator/ColumnCellFlotation_5.jpg
// module id = 421
// module chunks = 0